import React, { useEffect, useState } from 'react';
import api from '../../utils/axios';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { ClipboardList, RefreshCw, Check } from 'lucide-react';
import { PreviewTabla } from './PreviewTabla';

const COLUMNAS = (marcar) => [
  { key: 'cliente', label: 'Cliente', render: (r) => (
    <div><p className="font-medium text-slate-800">{r.detalle?.razon_social || '—'}</p><p className="text-slate-400 font-mono">{r.detalle?.cuit || ''}</p></div>
  ) },
  { key: 'origen', label: 'Origen', render: (r) => r.origen },
  { key: 'motivo', label: 'Motivo', render: (r) => r.detalle?.detalle || r.detalle?.motivo },
  { key: 'cvus', label: 'CVUs', render: (r) => {
    const d = r.detalle || {};
    const l = [...(d.cvus_anteriores || []), ...(d.cvus_nuevos || [])].map((c) => `${c.cvu} · ${c.banco}`);
    if (d.cvu_anterior) l.push(`${d.cvu_anterior} → ${d.cvu_nuevo}`);
    return l.map((t) => <p key={t} className="font-mono">{t}</p>);
  } },
  { key: 'accion', label: '', render: (r) => (
    <Button variant="outline" size="sm" className="h-7 text-xs" onClick={() => marcar(r.id)} data-testid={`revision-marcar-${r.id}`}>
      <Check size={12} className="mr-1" /> Revisado
    </Button>
  ) },
];

export const RevisionReemplazos = () => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const cargar = async () => {
    setLoading(true);
    try {
      const res = await api.get('/padron-interno/reemplazos-revision');
      setItems(res.data?.items || []);
      setTotal(res.data?.total || 0);
    } catch {
      toast.error('No se pudo cargar la revisión manual');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { cargar(); }, []);

  const marcar = async (id) => {
    try {
      await api.put(`/padron-interno/reemplazos-revision/${id}`, { estado: 'REVISADO' });
      toast.success('Marcado como revisado');
      cargar();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Error');
    }
  };

  return (
    <Card className="p-5 border-slate-200" data-testid="revision-reemplazos">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-amber-50"><ClipboardList size={18} className="text-amber-600" /></div>
        <div className="flex-1">
          <h3 className="font-semibold text-slate-900">Pendientes de revisión manual <span data-testid="revision-total">({total})</span></h3>
          <p className="text-xs text-slate-500">Casos ambiguos de "Sugerir" o "Importar". Se resuelven vinculando a mano desde la ficha del cliente o con un archivo de reemplazos.</p>
        </div>
        <Button variant="ghost" size="sm" onClick={cargar} disabled={loading} data-testid="revision-recargar">
          <RefreshCw size={14} className={loading ? 'animate-spin' : ''} />
        </Button>
      </div>
      <div className="mt-3">
        {items.length === 0
          ? <p className="text-sm text-slate-400" data-testid="revision-vacia">No hay pendientes.</p>
          : <PreviewTabla testid="revision-tabla" titulo="Pendientes" columnas={COLUMNAS(marcar)} filas={items} />}
      </div>
    </Card>
  );
};
